<div class="modal-backdrop" [@modalFadeIn]>
  <div class="modal-container">
    <div class="modal">
      <!-- Modal Header -->
      <div class="modal-header">
        <h3 class="modal-title">
          {{ upgradeSuccess() ? 'Upgrade Concluído!' : 'Confirmar Upgrade' }}
        </h3>
        <button mat-icon-button (click)="close()" aria-label="Fechar modal" [disabled]="isProcessing()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-dialog-content class="modal-body">
        <!-- Estado: Confirmação -->
        <ng-container *ngIf="!upgradeSuccess()">
          <!-- Comparação de Planos -->
          <section class="comparison-section">
            <div class="comparison-grid">
              <!-- Plano Atual -->
              <div class="plan-column current">
                <div class="plan-label">Plano Atual</div>
                <div class="plan-card">
                  <h4 class="plan-name">{{ data.currentPlan.name }}</h4>
                  <div class="plan-price">{{ formatCurrency(data.currentPlan.finalTotal || 0) }}<span>/mês</span></div>
                </div>
              </div>

              <!-- Seta -->
              <div class="arrow-column">
                <mat-icon>arrow_forward</mat-icon>
              </div>

              <!-- Novo Plano -->
              <div class="plan-column new">
                <div class="plan-label">Novo Plano</div>
                <div class="plan-card highlight">
                  <h4 class="plan-name">{{ data.targetPackage.name }}</h4>
                  <div class="plan-price">{{ formatCurrency(calculatePackageTotal(data.targetPackage)) }}<span>/mês</span></div>
                </div>
              </div>
            </div>

            <!-- Diferença de Preço -->
            <div class="price-difference">
              <mat-icon>trending_up</mat-icon>
              <span>Aumento de {{ formatCurrency(getPriceDifference()) }} por mês</span>
            </div>
          </section>

          <mat-divider></mat-divider>

          <!-- Benefícios do Upgrade -->
          <section class="benefits-section">
            <h3 class="section-title">O que você ganha com o upgrade</h3>

            <!-- Novos Itens -->
            <div class="benefit-group" *ngIf="getAddedItems().length > 0">
              <div class="benefit-header">
                <mat-icon>add_circle</mat-icon>
                <span class="benefit-title">Novos Recursos</span>
              </div>
              <ul class="benefit-list">
                <li *ngFor="let item of getAddedItems()">{{ item }}</li>
              </ul>
            </div>

            <!-- Itens Aumentados -->
            <div class="benefit-group" *ngIf="getUpgradedItems().length > 0">
              <div class="benefit-header">
                <mat-icon>arrow_upward</mat-icon>
                <span class="benefit-title">Recursos Ampliados</span>
              </div>
              <ul class="benefit-list">
                <li *ngFor="let item of getUpgradedItems()">{{ item }}</li>
              </ul>
            </div>

            <!-- Sem mudanças nos itens -->
            <div class="benefit-group" *ngIf="getAddedItems().length === 0 && getUpgradedItems().length === 0">
              <div class="benefit-header">
                <mat-icon>info_outline</mat-icon>
                <span class="benefit-title">Plano Superior</span>
              </div>
              <p class="benefit-description">
                Você terá acesso a um plano de maior valor com benefícios adicionais.
              </p>
            </div>
          </section>

          <mat-divider></mat-divider>

          <!-- Informações do Pagamento -->
          <section class="payment-info-section">
            <h3 class="section-title">Informações de Pagamento</h3>
            <div class="info-grid">
              <div class="info-item">
                <mat-icon>credit_card</mat-icon>
                <div class="info-content">
                  <span class="info-label">Parcelamento</span>
                  <span class="info-value">12x de {{ formatCurrency(calculatePackageTotal(data.targetPackage) / 12) }}</span>
                </div>
              </div>
              <div class="info-item">
                <mat-icon>event</mat-icon>
                <div class="info-content">
                  <span class="info-label">Primeira Cobrança</span>
                  <span class="info-value">30 dias após o último pagamento</span>
                </div>
              </div>
              <div class="info-item">
                <mat-icon>cancel</mat-icon>
                <div class="info-content">
                  <span class="info-label">Parcelas Canceladas</span>
                  <span class="info-value">Parcelas futuras do plano atual</span>
                </div>
              </div>
            </div>
          </section>

          <!-- Aviso Importante -->
          <section class="warning-section">
            <div class="alert alert-warning">
              <mat-icon>warning</mat-icon>
              <div>
                <strong>Atenção:</strong> Esta ação não pode ser desfeita. Ao confirmar, seu plano atual será desativado e um novo plano será criado imediatamente.
              </div>
            </div>
          </section>
        </ng-container>

        <!-- Estado: Sucesso -->
        <ng-container *ngIf="upgradeSuccess() && upgradeResponse()">
          <section class="success-section">
            <div class="success-icon">
              <mat-icon>check_circle</mat-icon>
            </div>
            <h3 class="success-title">Upgrade Realizado com Sucesso!</h3>
            <p class="success-message">
              Seu plano foi atualizado e você já tem acesso às novas funcionalidades.
            </p>

            <div class="success-details">
              <div class="detail-item">
                <span class="detail-label">Novo Plano:</span>
                <span class="detail-value">{{ upgradeResponse()?.newPlanName }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Valor Mensal:</span>
                <span class="detail-value">{{ formatCurrency(upgradeResponse()?.newMonthlyAmount || 0) }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Primeira Cobrança:</span>
                <span class="detail-value">{{ formatDate(upgradeResponse()?.firstPaymentDate) }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">Parcelas Canceladas:</span>
                <span class="detail-value">{{ upgradeResponse()?.cancelledInstallments }}</span>
              </div>
            </div>

            <div class="alert alert-success">
              <mat-icon>info_outline</mat-icon>
              <div>
                Você receberá uma notificação com todos os detalhes do upgrade. A primeira parcela do novo plano será cobrada em {{ formatDate(upgradeResponse()?.firstPaymentDate) }}.
              </div>
            </div>
          </section>
        </ng-container>
      </mat-dialog-content>

      <!-- Modal Actions -->
      <mat-dialog-actions class="modal-footer">
        <ng-container *ngIf="!upgradeSuccess()">
          <button mat-button (click)="close()" [disabled]="isProcessing()">
            Cancelar
          </button>
          <button 
            mat-flat-button 
            color="primary"
            [disabled]="isProcessing()"
            (click)="processUpgrade()">
            <mat-spinner *ngIf="isProcessing()" diameter="18" style="margin-right: 8px;"></mat-spinner>
            <mat-icon *ngIf="!isProcessing()">check</mat-icon>
            {{ isProcessing() ? 'Processando...' : 'Confirmar Upgrade' }}
          </button>
        </ng-container>
        <ng-container *ngIf="upgradeSuccess()">
          <button mat-flat-button color="primary" (click)="close()">
            <mat-icon>done</mat-icon>
            Fechar
          </button>
        </ng-container>
      </mat-dialog-actions>
    </div>
  </div>
</div>
